export const dropdowns = {
  LOCK_ACCOUNTS_MODAL: 'lock_accounts_modal',
  ACCOUNT_MAPPING_STATUS: 'account_mapping_status',
  ACCOUNT_MAPPING_REMAP: 'account_mapping_remap',
  ACCOUNT_MAPPING_TABLE_REMAP: 'account_mapping_table_remap',
  CHECKS_NOT_VISIBLE: 'checks_not_visible',
  INSIGHTS_ACTIONS: 'insights_actions',
  INSIGHTS_SAVE_QUERY: 'insights_save_query',
  OVERVIEW: 'overview',
  RECONCILIATION_CAROUSEL: 'reconciliation_carousel',
  PERIOD_PICKER: 'period_picker',
  REVIEW_FILTER: 'review_filter',
  REVIEW_COMMS_FILTER: 'review_comms_filter',
  WORKFLOW_STATUS: 'workflow_status',
  MESSAGE_VISIBILITY: 'message_visibility',
  PULSE_TEMPLATE_ACTIONS: 'pulse_template_actions',
  COPY_RECONCILIATION_DATA: 'copy_reconciliation_data',
  AI_CHAT_SESSIONS: 'ai_chat_sessions',
} as const

export type DropdownKeys = keyof typeof dropdowns
export type DropdownType = typeof dropdowns[keyof typeof dropdowns]

export const dropdownVariants = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  SEAMLESS: 'seamless',
} as const

export const alignOptions = {
  CENTER: 'c',
  LEFT: 'l',
  RIGHT: 'r',
} as const

export type DropdownVariant =
  typeof dropdownVariants[keyof typeof dropdownVariants]

export const dropdownSizes = {
  SMALL: 'small',
  DEFAULT: 'default',
} as const

export type DropdownSize = typeof dropdownSizes[keyof typeof dropdownSizes]

export const dropdownDrawerSizes = {
  DEFAULT: 'default',
  LARGE: 'large',
} as const

export type DropdownDrawerSize =
  typeof dropdownDrawerSizes[keyof typeof dropdownDrawerSizes]
